import * as React from "react";
import { cn } from "./utils";

const TextareaUI = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => {
  return (
    <textarea
      ref={ref}
      className={cn(
        "w-full",
        "bg-transparent border-none outline-none shadow-none",
        "text-sm leading-normal",
        "resize-none",
        "p-0",
        "focus:ring-0 focus:outline-none",
        className
      )}
      {...props}
    />
  );
});

TextareaUI.displayName = "TextareaUI";

export { TextareaUI };